import { noise } from './PerlinNoise.glsl';

export const fogParsVert = `
#ifdef USE_FOG
  varying float fogDepth;
  varying float fogHeight;
  varying vec3 vFogWorldPosition;
#endif
`;

// mvPosition = camera fog
// worldPosition = world fog
export const fogVert = `
#ifdef USE_FOG
  //fogDepth = - mvPosition.z;
  //vFogWorldPosition = worldPosition.xyz; // (modelMatrix * vec4(position, 1.0)).xyz;
  //fogHeight = worldPosition.y;
  
  fogDepth = - mvPosition.z;
  vFogWorldPosition = (modelMatrix * vec4(position, 1.0)).xyz;
  fogHeight = vFogWorldPosition.y;
#endif
`;

export const fogFrag = `
#ifdef USE_FOG
  vec3 windDir = vec3(0.0, 0.0, time*0.11);
  vec3 scrollingPos = vFogWorldPosition.xyz + fogNoiseSpeed * windDir;  
  float noise = cnoise(fogNoiseFreq * scrollingPos.xyz);
  float vFogDepth = (1.0 - fogNoiseImpact * noise) * fogDepth;
  #ifdef FOG_EXP2
  float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
  #else
  float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
  #endif
  float fogFactorB = fogFactor + smoothstep( fogCeiling, fogFloor, fogHeight);

  if (fogFactorB > 1.) {
    fogFactorB = 1.;
  }

  gl_FragColor.rgb = mix( gl_FragColor.rgb, mix(fogNearColor, fogHorizonColor, fogFactor), fogFactorB );
#endif
`;

export const fogParsFrag = `
#ifdef USE_FOG
  ${noise}
  uniform vec3 fogHorizonColor;
  uniform vec3 fogNearColor;
	varying float fogDepth;
	varying float fogHeight;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
  varying vec3 vFogWorldPosition;
  uniform float fogFloor;
  uniform float fogCeiling;
  uniform float time;
  uniform float fogNoiseSpeed;
  uniform float fogNoiseFreq;
  uniform float fogNoiseImpact;
#endif
`;